import React from 'react';
import { SearchBtnWrap, SearchIcon } from './styled';


interface IProps {
    isInactive?: boolean,
    onClick: () => void,
}

export const SearchBtn: React.FC<IProps> = ({ isInactive, onClick }) => {
    return (
        <SearchBtnWrap
            isInactive={!!isInactive}
            onClick={onClick}
        >
            <SearchIcon
                width='22'
                height='22'
                viewBox='0 0 22 22'
                fill='none'
                isInactive={!!isInactive}
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.3341 15.6667C12.3846 15.6667 15.6682 12.3834 15.6682 8.33333C15.6682 4.28325 12.3846
                    1 8.3341 1C4.28359 1 1 4.28325 1 8.33333C1 12.3834 4.28359 15.6667 8.3341 15.6667Z'
                    strokeWidth='1.3'
                />
                <path
                    d='M13.5 13.5L21 21'
                    strokeWidth='1.3'
                />
            </SearchIcon>
        </SearchBtnWrap>
    );
};
